import { Injectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * Carga el contenedor de Google Tag Manager de la web pública.
 * El gtmId viene de environment (dev y prod usan contenedores distintos).
 */
@Injectable({ providedIn: 'root' })
export class GtmService {
  private readonly document = inject(DOCUMENT);
  private cargado = false;

  cargar(gtmId: string): void {
    if (this.cargado || !gtmId) {
      return;
    }
    const ventana = this.document.defaultView as (Window & { dataLayer?: unknown[] }) | null;
    if (!ventana) {
      return;
    }
    ventana.dataLayer = ventana.dataLayer ?? [];
    ventana.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const script = this.document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    this.document.head.appendChild(script);
    this.cargado = true;
  }
}
